import {f, withBearer} from "data/fetch";

export type Params = {
  timestamp_start: string;
  timestamp_end: string;
};

export type ChangelogResp = {
  changelog_id: string;
  released_at: string;
  title: string;
  summary: string;
  body: {
    markdown: string;
    image_map: Record<string, string>;
  };
  tags: string[];
  seen: boolean;
  url: string | null;
};

export async function markSeenChangelogs(payload: string[]) {
  if (!payload.length) return;

  return await f<{created: string[]}>("v1/changelog_seen", {
    headers: withBearer(undefined, {"Content-type": "application/json"}),
    method: "POST",
    body: {
      seen: payload,
    },
  });
}

export async function getChangelogs(params: Params) {
  return await f<{items: ChangelogResp[]}>("v1/changelog", {
    headers: withBearer(),
    query: {
      timestamp_start: params.timestamp_start,
      timestamp_end: params.timestamp_end,
    },
  });
}
export async function loadMarkdownImages(changelogs?: ChangelogResp[]) {
  if (!changelogs) return;
  const urls: string[] = [];

  for (const item of changelogs) {
    const values = Object.values(item.body.image_map);
    urls.push(...values);
  }
  const cache = new Map<string, HTMLImageElement>();

  const promises = urls.map((url) => {
    const img = new Image();

    return new Promise((resolve, reject) => {
      img.src = url;
      img.onload = (v) => {
        cache.set(url, img);
        resolve(v);
      };
      img.onerror = reject;
      img.style.objectFit = "contain";
      img.style.objectPosition = "left center";
    });
  });
  await Promise.allSettled(promises);
  return cache;
}
